<!-- HTTP request loader overlay -->
<app-loader></app-loader>

<!-- PrimeNG toasts. The keyless outlet is the default (top-right); the keyed
     outlets let ToastService route a message to a chosen position via `key`. -->
<p-toast position="top-right"></p-toast>
<p-toast key="tl" position="top-left"></p-toast>
<p-toast key="tc" position="top-center"></p-toast>
<p-toast key="br" position="bottom-right"></p-toast>
<p-toast key="bl" position="bottom-left"></p-toast>
<p-toast key="bc" position="bottom-center"></p-toast>
<p-toast key="c" position="center"></p-toast>

<!-- Routed pages -->
<router-outlet></router-outlet>
